/**
 * @format
 */
import {
  ADD_LIST_VIEWER_REQUEST,
  ADD_LIST_VIEWER_SUCCESS,
  ADD_LIST_VIEWER_FAILURE,
} from '../actions';

export default (state, type, payload) => {
  switch (type) {
    case ADD_LIST_VIEWER_REQUEST: {
      const { viewerIds, willCallReload } = payload;
      const newLoadingMap = { ...state.listViewerLoadingMap };
      viewerIds.forEach(id => {
        newLoadingMap[id] = true;
      });
      return {
        ...state,
        listViewerLoadingMap: newLoadingMap,
        listViewerLoading: willCallReload,
      };
    }

    case ADD_LIST_VIEWER_SUCCESS: {
      const { viewerIds, listId } = payload;
      const newLoadingMap = {
        ...state.listViewerLoadingMap,
      };
      viewerIds.forEach(id => {
        newLoadingMap[id] = false;
      });

      const newMembers =
        payload.data === 'all'
          ? {}
          : payload.data.reduce((acc, member) => {
              acc[member.id] = member;
              return acc;
            }, {});

      const mergedListMembers = {
        ...state.listMembers,
        [listId]: {
          ...newMembers,
          ...(state.listMembers[listId] || {}),
        },
      };

      return {
        ...state,
        listMembers: payload.data === 'all' ? {} : mergedListMembers,
        listsWithAccessToAllMembers:
          payload.data === 'all'
            ? {
                ...state.listsWithAccessToAllMembers,
                [listId]: true,
              }
            : state.listsWithAccessToAllMembers,
        listViewerLoadingMap: newLoadingMap,
      };
    }

    case ADD_LIST_VIEWER_FAILURE: {
      const { viewerIds } = payload;
      const newLoadingMap = { ...state.listViewerLoadingMap };
      viewerIds.forEach(id => {
        newLoadingMap[id] = false;
      });
      return {
        ...state,
        listViewerLoadingMap: newLoadingMap,
      };
    }

    default:
      return state;
  }
};
